import { useCallback, useMemo } from 'react';

import {
  useRfqBuilderActions,
  useRfqBuilderView,
} from '@paradigm/features/src/unified-rfqs/ui';

import Badge from '@paradigm/design-system/src/components/Badge';
import { useTrackAction } from '@paradigm/features/src/analytics';
import { AuctionType } from '@paradigm/features/src/unified-rfqs/entities/shared';
import ToggleButton from './components/ToggleButton';

export default function AuctionButtons() {
  const { options, selectedOption } = useRfqBuilderView().auction;
  const { selectAuction } = useRfqBuilderActions();
  const trackAction = useTrackAction();

  const handleOnChange = useCallback(
    (auctionType: AuctionType) => {
      return () => {
        trackAction('update auction', { auctionType });
        selectAuction(auctionType);
      };
    },
    [selectAuction, trackAction],
  );

  return useMemo(
    () => (
      <>
        {options.map((option) => (
          <ToggleButton
            ariaLabel={`select ${option.label}`}
            key={option.value}
            active={option.value === selectedOption.value}
            disabled={option.disabled === true}
            title={
              option.disabled === true ? option.disabledTooltip : undefined
            }
            onClick={
              option.disabled === true
                ? undefined
                : handleOnChange(option.value)
            }
          >
            {option.disabled === true && option.disabledTooltip != null && (
              <Badge variant="count" top={-4} right={-8}>
                {option.disabledTooltip}
              </Badge>
            )}
            {option.label}
          </ToggleButton>
        ))}
      </>
    ),
    [handleOnChange, options, selectedOption.value],
  );
}
